import { Flex, Stack, Text } from '@mantine/core';
import type { UploadedFile } from 'src/data-capture/hooks/file-uploads/types';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  file: UploadedFile;
  isSelected: boolean;
  onSelect: () => void;
};

export const AgendaFileCard = ({ file, isSelected, onSelect }: Props) => {
  return (
    <Flex
      bg={isSelected ? 'brand.0' : 'gray.1'}
      style={{
        borderRadius: '16px',
        cursor: 'pointer',
        border: isSelected ? '2px solid var(--mantine-color-brand-6)' : '2px solid transparent',
      }}
      py="sm"
      px="md"
      justify="space-between"
      align="center"
      onClick={onSelect}
    >
      <Stack gap="xxxs">
        <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="gray.10">
          {file.file.fileName}
        </Text>
        <Text size="textXs" fw={FONT_WEIGHTS.regular} c="gray.7">
          Uploaded: {new Date(file.createdAt).toLocaleDateString()}
        </Text>
      </Stack>
      {isSelected && (
        <Text size="textSm" fw={FONT_WEIGHTS.semibold} c="brand.6">
          Selected
        </Text>
      )}
    </Flex>
  );
};
